import _ from 'lodash';
import { translationDictionary } from './SlugParser';

// per saber si hem de fer una url friendly (server) o amb querystring (static/export)
const _routePathType = {
    web: ''
};

const _routePathJitPub1 = {
    web_esports: 'https://www.3cat.cat/esport3/'
};

const _routePathJitPub2 = {
    web_butlletins_gestio: '/butlletins/',
    web_butlletins_item_butlleti: '/butlletins/{slug}/{id}/',
    web_canal_etic_home: '/canal-etic/',
    web_transparencia_home: '/corporatiu/transparencia/',
    web_transparencia_seccio: '/corporatiu/transparencia/{slug}/',
    web_transparencia_item_document: '/corporatiu/transparencia/{slug}/document/{id}/',
    web_transparencia_cerca: '/corporatiu/transparencia/resultats-cerca/?text={slug}',
    web_actualitat_seccio: '/3catinfo/{slug}/',
    web_actualitat_item_noticia: '/3catinfo/{slug}/noticia/{id}/',
    web_actualitat_item_noticia_amp: '/3catinfo/{slug}/noticia-amp/{id}/',
    web_sales_seccio: '/tv3/sales/{slug}/',
    web_sales_item_noticia: '/tv3/sales/{slug}/news/{id}/',
    web_sales_item_produccio: '/tv3/sales/{slug}/production/{id}/',
    web_rs_home: '/corporatiu/rs/',
    web_rs_seccio: '/corporatiu/rs/{slug}',
    web_rs_item_noticia: '/corporatiu/rs/{slug}/noticia/{id}/',
    web_canal_etic_seccio: '/canal-etic/{slug}/',
    web_3cat_programa: '/3cat/{slug}/',
    web_3cat_item_video: '/3cat/{slug}/video/{id}/',
    web_3cat_item_audio: '/3cat/{slug}/audio/{id}/',
    web_marato_item_noticia: '/tv3/marato/{slug}/noticia/{id}/',
    web_marato_item_galeria: '/tv3/marato/{slug}/foto-galeria/{id}/',
    web_marato_item_interactiu: '/tv3/marato/{slug}/interactiu/{id}/',
    web_marato_item_edicio: '/tv3/marato/{slug}/{id}/',
    web_marato_item_edicio_en: '/tv3/marato/en/{slug}/{id}/',
    web_marato_item_edicio_es: '/tv3/marato/es/{slug}/{id}/',
    web_marato_item_edicio_relacionats: '/tv3/marato/{slug}/{slug2}/{id}/',
    web_marato_recerca_relacionats: '/tv3/marato/recerca/{slug}/',
    web_sx3_item_noticia: '/tv3/sx3/{slug}/noticia/{id}/',
    web_sx3_programa: '/tv3/sx3/{slug}/'
};

const _routePaths = { ..._routePathJitPub1, ..._routePathJitPub2 };

const _getSlug = (cadena) => {
    let replaced;
    const translationDictionaryRegex = RegExp('[' + _.keys(translationDictionary).join('') + ']', 'gi');
    replaced = cadena.replace(translationDictionaryRegex, function (m) {
        let ret = translationDictionary[m.toUpperCase()];
        if (m === m.toLowerCase()) ret = ret.toLowerCase();
        return ret;
    });

    return replaced
        .replace(/[^a-zA-Z0-9\-_<>]/gi, '')
        .replace(/[\-]+/gi, '-')
        .replace(/<[^>]*>/gi, '')
        .replace(/^[-]/gi, '')
        .replace(/[-]$/gi, '')
        .toLowerCase();
};

const getRoutePath = (tipologia, domini) => {
    if (tipologia === 'NOT_NOTICIA') {
        switch (domini) {
            case 'PUS3':
                return 'web_sx3_item_noticia';
            case 'PUMAR':
                return 'web_marato_item_noticia';
            case 'PURS':
                return 'web_rs_item_noticia';
            default:
                return 'web_actualitat_item_noticia';
        }
    } else if (tipologia === 'DTY_VIDEO_MM') {
        return 'web_3cat_item_video';
    } else if (tipologia === 'WCR_AUDIO_MM') {
        return 'web_3cat_item_audio';
    } else if (tipologia === 'PTVC_PROGRAMA' || tipologia === 'WCR_PROGRAMA') {
        return 'web_3cat_programa';
    } else {
        return '#';
    }
};

/**
 * id: id del contingut
 * slug: titol del contingut, escapat en-format-url
 * slug2: titol del contingut, escapat en-format-url
 * params: titol del contingut, escapat en-format-url
 * routePath: força emprar el patró de friendly indicat explícitament
 **/

const getUrlFriendly = (props) => {
    let { id, slug, slug2, params, routePath, tipologia, domini } = props;
    try {
        slug = slug ? _getSlug(slug) : 'titol';
        slug2 = slug2 ? _getSlug(slug2) : 'titol';
        if (!(routePath && _routePaths[routePath])) {
            routePath = getRoutePath(tipologia, domini);
            if (routePath === '#') {
                return '#';
            }
        }
        routePath = _routePaths[routePath]
            .replace('{id}', id)
            .replace('{slug}', slug)
            .replace('{slug2}', slug2)
            .replace('{params}', params);
        return routePath;
    } catch (error) {
        console.log('Error Routeresolver', error);
        return '#';
    }
};

const getUrlCanonical = (props) => {
    const { id, routePath } = props;
    let { slug } = props;
    slug = slug ? _getSlug(slug) : 'titol';
    return _routePaths[routePath].replace('{id}', id).replace('{slug}', slug);
};

const getRouteType = (url) => {
    if (!url) return {};

    const convertToRegex = (pattern) => {
        return new RegExp('^' + pattern.replace(/{(\w+)}/g, '(?<$1>[^/]+)') + '$');
    };

    for (const [type, pattern] of Object.entries(_routePaths)) {
        const regexPattern = convertToRegex(pattern);
        const match = url.match(regexPattern);
        if (match) {
            return {
                type,
                ...match.groups
            };
        }
    }

    return {};
};

export { getRouteType, getUrlCanonical, getUrlFriendly };
